import { mergeDeepRight } from 'ramda';
import mcolors from 'material-colors';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { VictoryTheme } from 'victory';

// Source (not sure if naming is correct):
// https://material.io/color/#!/?view.left=0&view.right=0&primary.color=E0E0E0&secondary.color=FFAB00
export const colors = {
  white: '#ffffff',
  white93alpha: 'rgba(255, 255, 255, 0.93)',
  white80alpha: 'rgba(255, 255, 255, 0.80)',
  white60alpha: 'rgba(255, 255, 255, 0.60)',
  black: '#000000',
  grey300: '#e0e0e0',
  grey500: '#aeaeae',
  grey800: '#d8d8d8',
  gold300: '#ffdd4b',
  gold500: '#ff6d00',
  gold800: '#c67c00',
  red: '#d32f2f',
  green: '#388e3c',
  linkColor: '#1e6eff',
  hoveredBg: 'rgba(224, 224, 224, 0.2)',
};

export const lineHeight = 1.55;

export const fonts = {
  'font-family': 'Roboto, Helvetica, Arial, sans-serif',
};

export const gradients = {
  absolute: ['#fffbb8', '#e81a1e'],
  compare: ['#27a12d', '#fffbb8', '#e81a1e'],
  blank: [colors.grey300, colors.grey300],
};

export const media = {
  mobile: { maxWidth: 600 },
  tablet: { maxWidth: 1024 },
};

// Indices written in comments are from the mock
export const legendColors = [
  mcolors.green[700], // 1
  mcolors.red[700], // 2
  mcolors.blue[700], // 3
  mcolors.yellow[700], // 4
  mcolors.cyan[700], // 5
  mcolors.purple[700], // 6
  mcolors.orange[700], // 7
  mcolors.indigo[700], // 8
  mcolors.teal[700], // 9
  mcolors.pink[700], // 10
  mcolors.lime[700], // 11
  mcolors.lightBlue[700], // 12
  mcolors.deepOrange[700], // 13
  mcolors.deepPurple[700], // 14
  mcolors.amber[700], // 15
  mcolors.lightGreen[700], // 16
];

export const muiTheme = getMuiTheme({
  palette: {
    primary1Color: colors.gold500,
    accent1Color: colors.grey300,
  },
  toolbar: {
    backgroundColor: colors.white,
  },
  tabs: {
    backgroundColor: colors.white,
    textColor: colors.black,
    selectedTextColor: colors.black,
  },
  inkBar: {
    backgroundColor: colors.gold500,
  },
});

export const victoryTheme = mergeDeepRight(VictoryTheme.material, {
  axis: {
    style: {
      axis: {
        stroke: 'none',
      },
      ticks: {
        stroke: 'none',
      },
      grid: {
        stroke: colors.grey300,
        shapeRendering: 'crispEdges',
        strokeDasharray: [],
      },
      tickLabels: {
        fill: colors.black,
        fontSize: 16,
        fontWeight: 300,
      },
    },
  },
  bar: {
    style: {
      data: {
        shapeRendering: 'crispEdges',
      },
    },
  },
  commonAxis: {
    axis: {
      stroke: 'none',
      strokeWidth: 1,
      shapeRendering: 'crispEdges',
      pointerEvents: 'none',
    },
    grid: {
      stroke: '#e0e0e0',
      strokeWidth: 1,
      shapeRendering: 'crispEdges',
      pointerEvents: 'none',
    },
    tickLabels: {
      fill: '#AEAEAE',
      fontSize: 14,
      fontWeight: 300,
      fontFamily: 'Roboto',
      pointerEvents: 'none',
    },
  },
  commonAxisNoGrid: {
    axis: {
      display: 'none',
    },
    grid: {
      stroke: 'transparent',
      pointerEvents: 'none',
    },
    tickLabels: {
      fill: '#AEAEAE',
      fontSize: 14,
      fontWeight: 300,
      fontFamily: 'Roboto',
    },
  },
  chartLegend: {
    style: {
      labels: {
        fontFamily: 'Roboto',
        lineHeight: 1,
        letterSpacing: '0px',
        fontSize: 16,
        angle: 0,
      },
    },
  },
});

export default {
  colors,
  gradients,
  media,
  legendColors,
  fonts,
  space: [0, 8, 16, 32, 64, 128, 256, 512],
};



// WEBPACK FOOTER //
// ./src/theme.js